import { Injectable, Inject } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';

@Injectable(
    { providedIn: 'root' }
)
export class StorageService {

    private defaultStorage = 'local';
    private autoFillKey = 'setValueInForm';

    constructor(
        private communication: CommunicationService
    ) {
    }

    public setStorage(type) {
        this.defaultStorage = type;
    }

    private getStorageType() {
        var storage: any = null;
        switch (this.defaultStorage) {
            case 'local':
                storage = localStorage;
                break;
            default:
                storage = localStorage;
                break;
        }
        return storage;
    }

    public getData(key, callback) {
        var storage = this.getStorageType();
        var data = storage.getItem(key);
        if (data) {
            try {
                data = JSON.parse(data);
                callback(data);
            } catch (e) {
                callback(false);
            }
        } else {
            callback(false);
        }
    }

    public getSessionStorageData(key, callback) {
        var data = sessionStorage.getItem(key);
        if (data) {
            try {
                data = JSON.parse(data);
                callback(data);
            } catch (e) {
                callback(false);
            }
        } else {
            callback(false);
        }
    }

    public getSessionStorageDataSync(key) {
        var data = sessionStorage.getItem(key);
        if (data) {
            try {
                data = JSON.parse(data);
                return data;
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }
    public getLocalStorageDataSync(key):any {
        var data = localStorage.getItem(key);
        if (data) {
            try {
                data = JSON.parse(data);
                return data;
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }

    public getSessionStorageDataSimple(key, callback) {
        var data = sessionStorage.getItem(key);
        if (data) {
            callback(data);
        } else {
            callback(false);
        }
    }

    public setSessionStorageData(key, data, callback) {
        if (typeof data != 'string') {
            data = JSON.stringify(data);
        }
        sessionStorage.setItem(key, data);
        callback(true);
    }

    public removeSesssionData(key) {
        sessionStorage.removeItem(key);
    }

    // FUNCTION FOR GETTING THE VALUES FROM LOCALSTORAGE WHICH ARE IN STRING TYPE.
    public getDataString(key, callback) {
        var storage = this.getStorageType();
        var data = storage.getItem(key);
        if (data) {
            try {
                callback(data);
            } catch (e) {
                callback(false);
            }
        } else {
            callback(false);
        }
    }

    public setData(key, data, callback) {
        var storage = this.getStorageType();
        if (typeof data != 'string') {
            data = JSON.stringify(data);
        }
        storage.setItem(key, data);
        callback(true);
    }

    public removeData(key, callback) {
        var storage = this.getStorageType();
        storage.removeItem(key);
        callback(true);
    }
    
    public clearAllStorage(callback, session = true) {
        var storage = this.getStorageType();
        storage.clear();
        if (session) {
            sessionStorage.clear();
        }
        callback(true);
    }

    public setDataToAutofillForm(data, keyData, callback) {
        if (localStorage.getItem('filterValueInForm') != null || localStorage.getItem('filterValueInForm') != undefined || localStorage.getItem('filterValueInForm') != "") {
            localStorage.removeItem('filterValueInForm');
        }
        var obj = {};
        if (data.length > 0) {
            data.forEach(key => {
                Object.keys(key).forEach(set => {
                    obj[set] = key[set];
                    var obj1 = {};
                    if (Array.isArray(key[set])) {
                        key[set].forEach(setData => {
                            if (setData['type'] == 'static')
                                obj1[setData['key']] = setData['value'];
                            else
                                obj1[setData['key']] = keyData[setData['value']];
                        });
                    }
                    // obj['data'] = { ...obj1, ...keyData };
                    obj['data'] = { ...obj1 };
                });
            });
            this.setData('setValueInForm', JSON.stringify(obj), () => {
            });
            //localStorage.setItem('setValueInForm', JSON.stringify(obj));
        }
        else if (data) {
            this.setData('filterValueInForm', JSON.stringify(data), () => {
            });
        }
        callback(true);
    }

    public getAutofillData(id, callback) {
        this.getData(this.autoFillKey, (res) => {
            callback(res);
        });
    }

    reloadOtherTab() {
        this.setData("reload", new Date().getTime(), () => {
        });
    }

    getLocalStorageData(key){
        return localStorage.getItem(key)
    }

    setLocalStorageData(key, data,callback){
        if (typeof data != 'string') {
            data = JSON.stringify(data);
        }
        localStorage.setItem(key, data);
        callback(true);
    }


    public setCurrentResource(_value: any) {
        localStorage.setItem("CurrentResource", _value);
        this.communication.setStorageChange(_value);
    }
    setTabId(data, keys) {
        try {
            let data_ = JSON.parse(data);
            let str = this.createUniqueIdWithParams(data_, keys);
            let obj = {};
            let unqStr = str + Math.random();
            obj = localStorage.getItem('tabId') !=undefined && JSON.parse(localStorage.getItem('tabId'))?JSON.parse(localStorage.getItem('tabId')):{};
            obj[str] = unqStr;
            localStorage.setItem('tabId', JSON.stringify(obj));
            let sessionObj = {};
            sessionObj[str] = unqStr;
            sessionStorage.setItem('tabId', JSON.stringify(sessionObj));
            this.setData("restReload", Math.random().toString(), () => { });
        } catch (error) { }
    }

    createUniqueIdWithParams(data_, keys) {
        let str = "";
        for (let item of keys) {
            str = str + data_[item];
        }
        return str;
    }

    removeSessionStorageCurrentData(key="currentData") {
        this.getSessionStorageData(key, (res) => {
            if(res){
                this.removeSesssionData(key);
            }
        });
    }

    removeUrlHistory(url) {
        try {
            if (localStorage.getItem('urlCurrent') != undefined && JSON.parse(localStorage.getItem('urlCurrent')).length != undefined) {
                let urlData = JSON.parse(localStorage.getItem('urlCurrent'));
                let prevUrl = url;
                let indexOfprevUrl = urlData.indexOf(prevUrl);
                if (indexOfprevUrl != undefined && indexOfprevUrl > -1) {
                    urlData.splice(indexOfprevUrl, 1);
                    if (urlData.length == 0) {
                        localStorage.removeItem("urlCurrent");
                    }
                    else {
                        localStorage.setItem("urlCurrent", JSON.stringify(urlData));
                    }
                }
            }
        } catch (error) {

        }
    }

    getPatientInfo(): any {
        return this.getLocalStorageDataSync("patientDetails");
    }

    public getCurrentFacility(): any {
       return this.getLocalStorageDataSync("current_facility");
    }

    removeDublicacyInfo() {
        try {
            if (localStorage.getItem('storeInfoForDublicacy') != undefined && JSON.parse(localStorage.getItem('storeInfoForDublicacy')).length != undefined) {
                let Data = JSON.parse(localStorage.getItem('storeInfoForDublicacy'));
                let currentData = sessionStorage.currentData;
                if (currentData) {
                    let key = JSON.parse(currentData)['uhId'];
                    let indexOfprevUrl = Data.indexOf(key);
                    if (indexOfprevUrl != undefined && indexOfprevUrl > -1) {
                        Data.splice(indexOfprevUrl, 1);
                        if (Data.length == 0) {
                            localStorage.removeItem("storeInfoForDublicacy");
                        }
                        else {
                            localStorage.setItem("storeInfoForDublicacy", JSON.stringify(Data));
                        }
                    }
                }

            }
        } catch (error) {

        }
    }
}
